<p-inputgroup class="w-full min-w-76 max-w-xl">
  @if (hasSearchFields()) {
    <p-select
      class="w-auto max-w-1/2 flex-none"
      [options]="selectOptions()"
      optionLabel="displayName"
      optionValue="name"
      appendTo="body"
      [disabled]="disabled()"
      [ngModel]="searchField()"
      (ngModelChange)="onFieldChange($event)"
    />
  }
  <p-iconfield iconPosition="left">
    <p-inputicon class="z-2">
      <svg-icon
        class="text-text-common-primary"
        src="/assets/icons/general/search.svg"
      />
    </p-inputicon>
    <input
      pInputText
      type="search"
      [placeholder]="placeholder() | sentenceCase"
      [disabled]="disabled()"
      autocomplete="on"
      (keyup)="onKeyUp($event)"
      [ngModel]="searchTerm()"
      (ngModelChange)="onTermChange($event)"
    />
  </p-iconfield>
</p-inputgroup>
